import SEO, { breadcrumbLD } from "../components/SEO";
import { Link } from "react-router-dom";

const FAQS = [
    {
        q: "Que faire au Tréport en hiver ?",
        a: "Marcher sur les falaises de craie au lever du jour (le funiculaire fonctionne toute l'année), prendre un thé à l'Hôtel Le Saint-Yves face au port, visiter le Musée du Vieux-Tréport, déjeuner d'huîtres au marché aux poissons. Mers-les-Bains et ses villas Belle Époque sont à 800 m à pied.",
    },
    {
        q: "Quelle plage choisir entre Cayeux-sur-Mer et Le Tréport ?",
        a: "Cayeux-sur-Mer offre la plus longue plage de galets d'Europe (12 km) et 524 cabines polychromes — idéal pour la photo et le longe-côte. Mers-les-Bains a une plage de galets plus intime, dominée par 600 villas Belle Époque. Mesnil-Val (entre les deux) propose une crique préservée. Bois-de-Cise est le seul bois naturel descendant à la mer.",
    },
    {
        q: "Où dormir à Mers-les-Bains avec vue mer ?",
        a: "L'Hôtel L'Itinérance (sur l'esplanade du Général Leclerc, vue directe sur les villas et la plage) et Entre 2 Vagues (maison d'hôtes à 800 m de la plage) sont les deux meilleures options. Pour un séjour plus chic, Hôtel Le Cise à Bois-de-Cise (15 min) reste l'adresse de référence.",
    },
    {
        q: "Comment visiter le Château d'Eu ?",
        a: "Le Château d'Eu, ancienne résidence d'été de Louis-Philippe, abrite aujourd'hui le Musée Louis-Philippe. Visite libre ou guidée d'avril à octobre. À 1 km, le Domaine de Joinville (ferme modèle de 1830) propose chambres d'hôtes et tea time du chef Ludovic Eloy.",
    },
    {
        q: "Quelle randonnée faire en Forêt d'Eu ?",
        a: "Six boucles balisées entre 4 et 21 km : le Circuit de Rieux (11 km, départ village de Rieux), Saint-Pierre-en-Val avec la Triple Hêtraie et le site Briga gallo-romain, le court Circuit de la Reine Mère (4,5 km, famille), le Circuit de Gérente (18 km, vrais marcheurs), et la grande Boucle d'Incheville par les étangs (21,5 km). Toutes les traces GPX sont sur Côte Perdue.",
    },
    {
        q: "Qu'est-ce que la Vallée du Verre ?",
        a: "La Vallée de la Bresle, entre Blangy-sur-Bresle et Le Tréport, concentre 75% de la production mondiale de flacons de parfum. Sept manufactures verrières — Pochet du Courval, Saver-Glass, Bormioli — y soufflent à la canne les flacons Chanel, Dior, Guerlain. Le Musée du Verre de Blangy retrace cette histoire.",
    },
    {
        q: "Combien de temps pour aller du Tréport à la Baie de Somme ?",
        a: "30 minutes en voiture jusqu'à Cayeux-sur-Mer (porte sud de la Baie de Somme), 50 minutes jusqu'à Saint-Valery-sur-Somme. Côte Perdue couvre les 80 km qui vont de Berneval-le-Grand (Seine-Maritime) à Cayeux (Somme), incluant Mers-les-Bains, Eu, Bois-de-Cise et Ault.",
    },
    {
        q: "Quels jardins remarquables visiter ?",
        a: "Trois jardins labellisés « Jardin Remarquable » dans la zone : le Parc du Bois des Moutiers à Varengeville (Lutyens & Jekyll, 1898), le Jardin Shamrock (collection nationale d'hortensias, 1 700 variétés), et le Jardin du Vasterival de la Princesse Sturdza (sur RDV uniquement, considéré parmi les 10 plus beaux d'Europe).",
    },
    {
        q: "Le territoire couvre la Normandie ou la Picardie ?",
        a: "Les deux. Côte Perdue couvre 80 km de côte qui réunissent la Haute-Normandie (Le Tréport, Eu, Mesnil-Val, Berneval-le-Grand, Aumale, Neufchâtel-en-Bray) et la Picardie / Hauts-de-France (Mers-les-Bains, Bois-de-Cise, Ault, Cayeux-sur-Mer). La frontière administrative entre Seine-Maritime et Somme coupe une plage en deux — personne ici n'y prête attention.",
    },
    {
        q: "Comment fonctionnent vos sélections d'adresses ?",
        a: "Trois critères stricts : note Google ≥ 4,5/5, au moins 50 avis, et un audit photo manuel pour écarter les fast-foods, chaînes et établissements hors ligne éditoriale bohème-chic. Les 289 adresses publiées sont vérifiées une à une. Aucune commission cachée, aucune contrepartie.",
    },
];

export default function FAQ() {
    const faqLD = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": FAQS.map(f => ({
            "@type": "Question",
            "name": f.q,
            "acceptedAnswer": { "@type": "Answer", "text": f.a },
        })),
    };

    return (
        <div className="bg-cp-ivoire min-h-screen pt-28 pb-24" data-testid="faq-page">
            <SEO
                title="FAQ — Tout savoir sur la côte chic Normandie & Picardie"
                description="Que faire au Tréport en hiver, quelle plage entre Cayeux et Le Tréport, où dormir à Mers-les-Bains : 10 réponses sur la côte de Normandie & Picardie."
                path="/faq"
                structuredData={[
                    faqLD,
                    breadcrumbLD([
                        { name: "Accueil", path: "/" },
                        { name: "FAQ", path: "/faq" },
                    ]),
                ]}
            />

            <section className="max-w-[900px] mx-auto px-6 md:px-12">
                <p className="cp-tiny text-cp-foret mb-8">Questions fréquentes</p>
                <h1 className="cp-serif text-5xl md:text-7xl leading-[0.95] text-cp-encre tracking-[-0.025em] mb-6">
                    10 réponses sur cette<br />
                    <em className="cp-display-italic text-cp-foret">côte de craie</em>.
                </h1>
                <p className="cp-serif italic text-xl text-cp-gris max-w-2xl mb-16">
                    Ce que vous nous demandez le plus souvent — sur Le Tréport, Mers-les-Bains, Cayeux-sur-Mer, Eu, Bois-de-Cise et le reste du territoire.
                </p>

                <div className="divide-y divide-cp-border" data-testid="faq-list">
                    {FAQS.map((f, i) => (
                        <details key={i} className="group py-8" data-testid={`faq-item-${i}`}>
                            <summary className="cursor-pointer list-none flex justify-between items-baseline gap-4">
                                <h2 className="cp-serif text-2xl md:text-3xl text-cp-encre group-hover:text-cp-foret transition-colors">{f.q}</h2>
                                <span className="cp-tiny text-cp-foret transition-transform group-open:rotate-45 shrink-0">+</span>
                            </summary>
                            <p className="cp-serif text-lg leading-[1.7] text-cp-gris mt-6 max-w-3xl">{f.a}</p>
                        </details>
                    ))}
                </div>

                <hr className="border-cp-border my-20" />

                <div className="text-center">
                    <p className="cp-script text-3xl text-cp-foret mb-4">Une autre question ?</p>
                    <Link to="/contact" data-testid="faq-contact-link" className="cp-tiny tracking-[0.3em] text-cp-encre border-b-2 border-cp-foret pb-1 hover:text-cp-foret transition-colors">
                        ÉCRIVEZ-NOUS →
                    </Link>
                </div>
            </section>
        </div>
    );
}
